<template>
	<el-dialog :visible.sync="visible"
		:title="$t('retailInstance.text.batchRepassord')"
		:close-on-click-modal="false"
		:before-close="handleClose" class="bind-dialog  create-host batch-set-password-container-box ">
        <div class="tip-warning mb20" style="line-height: 19px"
             v-html="$t('privateNetInstance.batchRepassordTips')">
        </div>
        <batch-instance-table v-bind="$attrs" :multipleSelection="multipleSelection">
        </batch-instance-table>
        <div style="margin-top: 30px;" class="input-block">
            <el-form ref="ruleForm" label-width="100px" :model="ruleForm" :rules="rules">
                <!--新密码-->
                <el-form-item :label="$t('passwordReset.newPassword')|withColon" required prop="newPassword"
                                :show-message="false" ref="newPassword">
                    <el-input v-model="ruleForm.newPassword" 
                        :type="newPasswordVisible ? 'text' : 'password'"
                        auto-complete="off">
                        <!-- 小眼睛图标，点击切换显隐 -->
                        <i slot="suffix"
                            class="el-input__icon el-icon-view"
                            :style="{ color: newPasswordVisible ? '#409EFF' : '#c0c4cc' }"
                            @click="newPasswordVisible = !newPasswordVisible"></i>
                        </el-input>
                    <p class="el-form-item-help color-gray"
                    :class="{'el-form-item-help-error': ruleFormTag.newPassword === 'error'}">
                    {{$t('create.help.password')}}
                    </p>
                </el-form-item>
                <!--确认密码-->
                <el-form-item :label="$t('create.text.passwordConfirm')|withColon" required prop="newPasswordConfirm">
                    <el-input v-model="ruleForm.newPasswordConfirm" 
                        :type="confirmPasswordVisible ? 'text' : 'password'"
                        auto-complete="off">
                            <!-- 小眼睛图标，点击切换显隐 -->
                            <i slot="suffix"
                                class="el-input__icon el-icon-view"
                                :style="{ color: confirmPasswordVisible ? '#409EFF' : '#c0c4cc' }"
                                @click="confirmPasswordVisible = !confirmPasswordVisible"></i>
                        </el-input>
                </el-form-item>
            </el-form>
        </div>
        
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind"
				type="primary">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import BatchInstanceTable from '@/components/common/BatchInstanceTable';
import {ChargeModeMap, CreateTypeConstant, PasswordRuleConstant} from '@/common/Constants';
export default {
	name: 'BatchRepassword',
    components: {
        BatchInstanceTable
    },
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		multipleSelection: {
			type: Array,
			default: []
		},
		region: {
			type: String,
			default: ''
		}
	},
	data() {
        // 新密码验证validator
        const validatePassword = (rule, value, callback) => {
        if (value === '') {
            callback(new Error(this.$t('create.placeholder.passNull')))
        } else {
            // 密码校验规则(8-30个字符，且同时包含三项（大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:";'<>,.?/）。)
            const rule = PasswordRuleConstant
            if (this.ruleForm.newPasswordConfirm !== '') {
                this.$refs.ruleForm.validateField('newPasswordConfirm')
            }
            const result = rule.test(value)
            if (!result) {
                callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
            }
            callback();
        }
        this.ruleFormTag.newPassword = this.$refs.ruleForm.validateState
        }
        const validatePasswordConfirm = (rule, value, callback) => {
            if (value === '') {
            callback(new Error(this.$t('create.placeholder.confirmPassNull')))
            } else if (value !== this.ruleForm.newPassword) {
            callback(new Error(this.$t('create.placeholder.passNotSame')))
            } else {
            callback();
            }
        }
		return {
            ruleForm: {
            // 新密码
            newPassword: '',
            // 确认密码
            newPasswordConfirm: ''
            },
            ruleFormTag: {
            newPassword: 'valid',
            },
            rules: {
            newPassword: [
                {validator: validatePassword, trigger: 'blur'}
            ],
            newPasswordConfirm: [
                {validator: validatePasswordConfirm, trigger: 'blur'}
            ]
            },
            // 新密码显示状态，默认为 false（隐藏）
            newPasswordVisible: false,
            // 确认密码显示状态，默认为 false（隐藏）
            confirmPasswordVisible: false,
        };
	},
    computed: {
      CreateTypeConstant: () => CreateTypeConstant,
    },
	methods: {

		handleClose() {
            // 重置密码显示状态
            this.newPasswordVisible = false;
            this.confirmPasswordVisible = false;
            this.resetInitParams();
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
        sureBind() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                } else {
                    this.resetPassword();
                }
            })
        },
        resetInitParams() {
            this.$refs.ruleForm.resetFields();
        },
		resetPassword() {
			let instanceIds = this.multipleSelection.map(item => item.instanceId)
			const params = {
				region: this.region,
                password: this.ruleForm.newPassword,
                clientToken: Normal.getClientToken(),
				instanceIds
			};

			Ajax.put('/api/cps/resetPasswords', params,{
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
				this.$emit('refresh');
			});
		},
	}
};
</script>
<style lang="scss" scoped>
.batch-set-password-container-box {
    // 优化密码框高度
  .el-form-item.is-success.is-required {
      margin-bottom: 0!important;
      height: 81px!important;
    }
    .el-form-item.is-required {
      margin-bottom: 0!important;
      height: 81px!important;
    }
    
    .el-form-item.is-error.is-required {
        margin-bottom: 0!important;
        height: 81px!important;
    }
    .el-form-item__error:first {
        display: none!important;
    }
    // .el-form-item {
    //     height: 81px!important; 
    // }
    /* 密码框小眼睛 */
    .el-input__icon.is-active {
      color: #409eff;
    }
}
</style>
<style lang="scss">
	.bind-dialog {
		.chooseInfo {
			margin-bottom: 5px;
			font-size: 12px;
		}
	}

    .input-block {
        width: 90%;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/BatchRepassword.vue